import {
  USER_FRUI_PFBZ_MODAL_CHANGE,
} from './constants';

export function frui_pfbzModalChange(visible,type) {
  return {
    type: USER_FRUI_PFBZ_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USER_FRUI_PFBZ_MODAL_CHANGE:
      return {
        ...state,
        frui_pfbzModalType:action.data.type,
        frui_pfbzModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/user/redux/frui_pfbzModalChange.js